<template>
  <div class="order auditFinancial">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.auditDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务审核</h3>
      <ny-date-range @change="dateChange" class="el-date-editor" :shortcut="true" v-model="date"></ny-date-range>
      <div class="selectBox">
        <ny-select
          :data="financial.examTypeMenu"
          v-model="financial.curExamType"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="examType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <ny-select
          :data="financial.examTypesMenu"
          v-model="financial.curExamTypes"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userMenu"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-input class="searchBox" icon="search" v-model="accountName" placeholder="请输入账号名称"></el-input>
        <el-input class="searchBox" icon="search" v-model="adverName" placeholder="请输入广告主名称"></el-input>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.auditPage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        >
          <template slot v-if="financial.auditPage.data.length>0">
            <el-table-column fixed="right" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handleAudit(scope.$index, scope.row)"
                  type="primary"
                  size="small"
                  v-if="scope.row.status === '待审核'"
                >审核</el-button>
                <el-button
                  @click="handleShow(scope.$index, scope.row)"
                  class="is-view"
                  type="primary"
                  size="small"
                  v-else
                >查看</el-button>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, NyDateRange } from '@/global/components';
import { mapGetters } from 'vuex';
export default {
  name: 'advertiser',
  data () {
    return {
      adver: {
        value: ''
      },
      adverName: '',
      accountName: '',
      downloadExc: '',
      date: [],
      startTime: '',
      endTime: '',
      page: {
        headers: {
          name: '财务',
          adName: '广告名称',
          id: 'ID',
          status: '审核状态'
        },
        data: [
          {
            name: '1345',
            adName: '创意',
            id: '12',
            status: '已通过'
          },
          {
            name: '1345',
            adName: '创意',
            id: '11',
            status: '待审核'
          },
          {
            name: '1345',
            adName: '创意',
            id: '13',
            status: '未通过'
          }
        ]
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      await this.$store.dispatch('finance/getExamTypeMenu')
      await this.getExamTypes({ value: this.financial.curExamType })
      this.getFinAuditInfo()
    },
    async getExamTypes ({ value } = {}) {
      await this.$store.dispatch('finance/getExamTypesMenu', {
        type: value
      })
    },
    getFinAuditInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('finance/getAuditFinTable', {
        type: this.financial.curExamTypes,
        currentPage,
        pageSize,
        accountName: this.accountName,
        userId: this.adver,
        userName: this.adverName,
        startTime: this.startTime,
        endTime: this.endTime
      })
    },
    changeSelect ({ value, type }) {
      if (type === 'examType') {
        this.getExamTypes({ value })
      }
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getFinAuditInfo({ currentPage, pageSize })
    },
    disDate (time) {
      return new Date(time) > Date.now();
    },
    dateChange (date) {
      this.startTime = date[0]
      this.endTime = date[1]
    },
    searchData () {
      this.financial.auditPage.resetData()
      this.getFinAuditInfo()
    },
    handleShow (index, row) {
      this.$router.push({ name: 'showAuditDetails', params: { id: row.id } })
    },
    handleAudit (index, row) {
      this.$router.push({ name: 'auditDetails', params: { id: row.id } })
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    NyDateRange
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.auditFinancial {
  .el-date-editor {
    margin-left: 20px;
    margin-top: 20px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
}
</style>
